import React, {useEffect, useState} from "react";
import AppRoutes from "../AppRoutes";
import NavBar from "./Navigation/NavBar";
import AppsSidebar from "./Navigation/AppsSidebar";
import {SystemError} from "./Error/SystemError";
import {AppUnloadLogout} from "./Logout/AppUnloadLogout";
import useAppContext from "../util/AppContext";
import {SessionContext} from "../util/SessionContext";
import EventBus from "../util/EventBus";
import {UnsavedChangesProvider} from "../util/UnsavedChanges";

export default function Layout() {
    const sessionContext: SessionContext = useAppContext()?.sessionContext!;
    const [loggedIn, setLoggedIn] = useState<boolean>(!!sessionContext?.valid());

    useEffect(() => {
        const onSessionUpdate = () => setLoggedIn(!!sessionContext?.valid());
        EventBus.session.addListener("update", onSessionUpdate);
        onSessionUpdate();
        return () => {
            EventBus.session.removeListener("update", onSessionUpdate);
        };
    }, [sessionContext]);

    return (
        // WRAPPED HERE RATHER THAN AROUND ONE PAGE'S TABS, so a panel that can hold unsaved work
        // registers wherever it is rendered and the lifecycle buttons that ask about it can live on
        // a different page. Nothing renders from the registry -- it is read only when a button is
        // pressed -- so an app-wide provider costs a context and no re-renders.
        <UnsavedChangesProvider>
            <div style={{display: "flex", flexDirection: "column", height: "100vh"}}>
                <NavBar />
                <div style={{display: "flex", flexDirection: "row", flex: 1, minHeight: 0}}>
                    {loggedIn && <AppsSidebar />}
                    <div style={{flex: 1, overflow: "auto"}}>
                        <AppRoutes />
                    </div>
                </div>
                <AppUnloadLogout />
                <SystemError />
            </div>
        </UnsavedChangesProvider>
    );
}

